import React from "react";
import moment from "moment";
import clsx from "clsx";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import BaseDialog from "../../../../../../../../../components/BaseDialog/BaseDialog";
import {NameColNew} from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/Portfolio/table-data";
import CalendarFormElement from "../../../../formElement/CalendarFormElement";
import PrimaryButton from "../../../../../../../../../components/Buttons/PrimaryButton";
import {DATE_FORMAT} from "../../../../../../../../../utils/constants";
import {DateQuestionMethods} from "../../../../question/DateQuestion";
import {TRANSACTION_START_DATE} from "../../../../../../../../Trades/constants";
import AggregatedDepotsSwitch
  from "../../../../../../../../CustomerDashboardV2/components_v2/AggregatedDepotsSwitch/AggregatedDepotsSwitch";
import {BOOKING_DATE_INFO, newDesignInputCustomClasses} from "../../../../../../../constants";
import {DisabledReasonTooltip} from "../../../../../../../../../components/Tooltip";
import CheckboxFormElement from "../../../../formElement/CheckboxFormElement/CheckboxFormElement";

import useStyles from "./styles";


const MIN_FROM_DATE = moment().add(1,'days');

const _convertToForm = (plan) => ({
  is_right_away: plan.deposit_from_type !== TRANSACTION_START_DATE.date,
  deposit_from_date: plan.deposit_from_date,
  populate: false,
});

const _convertFromForm = (formData) => ({
  deposit_from_type: formData.is_right_away ? TRANSACTION_START_DATE.rightAway : TRANSACTION_START_DATE.date,
  deposit_from_date: formData.deposit_from_date
});

const SingleBuyBookingDate = (props) => {
  const {
    item,
    onChange,
    hasMultipleOrders,
  } = props;

  const componentClasses = useStyles();
  const [settingsModalOpen, setSettingsModalOpen] = React.useState(false);
  const [formData, setFormData] = React.useState(_convertToForm(item));

  const handleClose = () => {
    setSettingsModalOpen(false);
    setFormData(_convertToForm(item)); // cancel changes
  };
  const handleSave = () => {
    if(!formData.is_right_away) {
      // validate booking date
      const startDateQ = {
        optional: false,
        answer: formData.deposit_from_date,
        min_date: MIN_FROM_DATE,
        disable_weekends: true
      };
      if (!DateQuestionMethods.valid(startDateQ)) {
        setFormData({...formData, deposit_from_date_error: startDateQ.error});
        return false
      }
    }

    onChange(item, _convertFromForm(formData), hasMultipleOrders && formData.populate);
    setSettingsModalOpen(false);
  };

  const handleDateChange = (value) => {
    setFormData({...formData, deposit_from_date: value, deposit_from_date_error: null, is_right_away: !value})
  };

  const handleToggleChange = (checked) => {
    const newData = {...formData, is_right_away: checked, deposit_from_date_error: null};
    if(checked){
      newData.deposit_from_date = null;
    }
    setFormData(newData)
  };

  const isDisabled = !_.isFunction(onChange);

  const openForm = () => {
    if(!isDisabled) {
      setFormData(_convertToForm(item)); // init
      setSettingsModalOpen(true);
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={true}>
        <Grid container>
          <Grid item xs={12}>
            <span className={clsx(componentClasses.label, isDisabled && 'disabled')}>
              {item.deposit_from_type === TRANSACTION_START_DATE.date ? moment(item.deposit_from_date).format(DATE_FORMAT) : 'Sofort'}
            </span>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={'auto'}>
        <DisabledReasonTooltip title={isDisabled && "Ein Datum für den Kauf wird von der gewählten Depotbank nicht unterstützt."}>
          <i className={clsx('far fa-calendar-edit', componentClasses.icon, isDisabled && 'disabled')} onClick={openForm} />
        </DisabledReasonTooltip>
      </Grid>
      <BaseDialog
        open={settingsModalOpen}
        handleClose={handleClose}
        title={'Ausführung Datum'}
        maxWidth={'sm'}
        actions={
          <Grid container justify={"flex-end"} spacing={2}>
            <Grid item xs={12} sm={'auto'}>
              <PrimaryButton
                text="Abbrechen"
                variant="outlined"
                onButtonClick={handleClose}
              />
            </Grid>
            <Grid item xs={12} sm={'auto'}>
              <PrimaryButton text={"Speichern"} onButtonClick={handleSave} />
            </Grid>
          </Grid>
        }
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div>Für Order:</div>
            <div>{NameColNew.body[0]({item: item.data || item, options: {hideAcceptanceCriteriasUnderName: true}})}</div>
          </Grid>
          <Grid item xs={12}>
            <CalendarFormElement
              label={'Datum'}
              value={formData.deposit_from_date}
              onChange={handleDateChange}
              minDate={MIN_FROM_DATE}
              disableWeekends
              required={!formData.is_right_away}
              error={formData.deposit_from_date_error}
              custom_classes={newDesignInputCustomClasses}
            />
          </Grid>
          <Grid item xs={12}>
            <AggregatedDepotsSwitch
              title={<>Sofort<span style={{marginLeft: '2em', fontFamily: 'Roboto-Regular'}}>{BOOKING_DATE_INFO}</span></>}
              value={formData.is_right_away}
              onChange={handleToggleChange}
            />
          </Grid>
          {hasMultipleOrders && (
            <Grid item xs={12}>
              <CheckboxFormElement
                label={'Auswahl für alle Order übernehmen'}
                value={formData.populate}
                onChange={(val) => setFormData({...formData, populate: val})}
                custom_classes={{label: componentClasses.checkboxLabel}}
              />
            </Grid>
          )}
        </Grid>
      </BaseDialog>
    </Grid>
  )
};

export default SingleBuyBookingDate;